import React from 'react';
import backgroundPhoto from '../../../assets/images/mainBlur.webp'
import {FlexWrapper} from "../../../components/FlexWrapper";
import {Container} from "../../../components/container/Container";
import {Button} from "../../../components/Button";
import {S} from './Main_Styles'
import Typewriter from 'typewriter-effect';

export const Main = () => {
    const onClckHandler=()=>{
        const targetElement = document.getElementById("contact");
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }    }
    return (
        <S.Main >
            <S.BackgroundWrapper>
                <Container>


                    <S.MainContainer>
                        <FlexWrapper direction="column" align={'flex-start'} justify={'center'} text_align={'left'}
                                     gap={'40px'}>

                            <S.MainTitle>Professional House Cleaning Services in Adelaide
                            </S.MainTitle>
                            <S.MainText>
                                Top-rated house cleaning service in Adelaide.<br/><br/>
                                Get your home sparkling clean with our trusted, fully insured cleaners.<br/>
                                We guarantee your satisfaction, if you're not 100% happy, we’ll re-clean your space for
                                free within 48 hours.

                            </S.MainText>
                            <Button width={'200px'} height={'50px'} fontSize={'20px'} onClick={onClckHandler}> Request a quote</Button>
                            <S.MobileMainPhotoWrapper src={backgroundPhoto}/>
                        </FlexWrapper>
                    </S.MainContainer>

                </Container>
            </S.BackgroundWrapper>

        </S.Main>
    );
};

